import { useTranslation } from "react-i18next";
import { handleFormChange } from "../../components/modals/EditableTable";
import { USER_ACCESS_NOTIFICATION_ROWS } from "./userAccessFormUi";

const NotificationCheckbox = ({ name, checked, disabled, onChange, title }) => (
  <div className="user-access-notif-check user-access-notif-check--inline">
    <input
      type="checkbox"
      className="user-access-notif-check__input"
      name={name}
      checked={!!checked}
      disabled={disabled}
      title={disabled ? title : undefined}
      onChange={onChange}
    />
  </div>
);

const UserAccessNotificationMatrix = ({ data, setData }) => {
  const { t } = useTranslation();
  const onToggle = (e) => handleFormChange(e, data, setData);
  const disabledTip = t("settingsUsers.notifChannelDisabled");

  return (
    <div className="user-access-notif-matrix">
      <div className="user-access-notif-matrix__header">
        <span className="user-access-notif-matrix__header-label" />
        <span className="user-access-notif-matrix__header-channel">
          {t("settingsUsers.notifChannelMail")}
        </span>
        <span className="user-access-notif-matrix__header-channel">
          {t("settingsUsers.notifChannelSms")}
        </span>
        <span className="user-access-notif-matrix__header-channel">
          {t("settingsUsers.notifChannelPush")}
        </span>
      </div>

      {USER_ACCESS_NOTIFICATION_ROWS.map((row) => (
        <div key={row.labelKey} className="user-access-notif-matrix__row">
          <span className="user-access-notif-matrix__row-label">
            {t(row.labelKey)}
          </span>
          <div className="user-access-notif-matrix__channels">
            <NotificationCheckbox
              name={row.mail}
              checked={data[row.mail]}
              onChange={onToggle}
            />
            <NotificationCheckbox
              name={row.sms}
              checked={data[row.sms]}
              disabled={row.smsDisabled}
              title={disabledTip}
              onChange={onToggle}
            />
            <NotificationCheckbox
              name={row.push}
              checked={data[row.push]}
              disabled={row.pushDisabled}
              title={disabledTip}
              onChange={onToggle}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default UserAccessNotificationMatrix;
